import React, {useEffect} from "react";
import {useSnapshot} from "valtio";
import {state, setModel,toggleDoubleSided} from "../../state";

const UIAPI = () => {
  
  const {openStatus, isLoaded} = useSnapshot(state);
  
  // set to init only once - then update as needed
  useEffect(() => {
    
    window.addEventListener("message", (event) => {
      if(isLoaded && typeof(event.data) === "string")
      {
        if(event.data === "toggle-double-sided")
        {
          toggleDoubleSided();
        }
        else if(JSON.parse(event.data))
        {
          let data = event.data.replace(/Tray1|Frame/g,`scaleOverride":[1,1,1],"materialOverride`).replace(/\/static":""/,'/static":{"materialOverride":"","scaleOverride":[1,1,1]}');
          const jsonData = JSON.parse(data);
          setModel(jsonData);
        }
      }
    }, false);
    
    
    // --------------------------------------------------
    // --------------------------------------------------
    //tests
    
/*     const dataFromApi = {
      "currentHeadboard": {"test-h": "Cedar Grain"},
      "currentFootboard": {"test-f": "Cedar Grain"},
    }
    
    const moreDataFromApi = {
      "currentFootboard": {"test-f": "Blood Moon Red"},
    }
    
    const evenMoreDataFromApi = {
      "currentHeadboard": {"test-h": "Blood Moon Red"},
    }
    
    const muchMoreDataFromApi = {
      "currentFootboard": {"test-f2": "Blood Moon Red"},
    }
  
    const removeDataFromApi = {
      "currentHeadboard": null,
    }
    
    setTimeout(() => {
      setModel(dataFromApi)
    }, 2000)
    
    setTimeout(() => {
      setModel(moreDataFromApi)
    }, 4000)
    
    setTimeout(() => {
      setModel(evenMoreDataFromApi)
    }, 6000)
    
    setTimeout(() => {
      setModel(muchMoreDataFromApi)
    }, 8000)
  
    setTimeout(() => {
      setModel(removeDataFromApi)
    }, 12000) */
    

    
  }, []);
  
  
  // feature toggle - updates every time 'openStatus' changes
  useEffect(() => {
    
    if(window.top.window !== window)
    {
      if (openStatus) {
        let data = {"title": "open-state", "value": "open"};
        window.top.window.postMessage(JSON.stringify(data),'*')
      } else {
        let data = {"title": "open-state", "value": "close"};
        window.top.window.postMessage(JSON.stringify(data),'*')
      }
    }
    
    // after this updates and posts, the new data will be received by the listener above
    console.log('openStatus', openStatus)
    
  }, [openStatus])
  
  
};

export default UIAPI;

